import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import WorkspacePremiumOutlinedIcon from '@guildeducationinc/recess/icons/WorkspacePremiumOutlinedIcon';
import styles from './NonProfitFeature.module.scss';

interface Props {
	isNonProfit: boolean;
}

export const NonProfitFeature: React.FC<Props> = ({ isNonProfit }) => {
	const isMobile = useIsMobile();
	if (!isNonProfit) {
		return null;
	}
	return (
		<span className={styles.featureSpan} data-testid='non-profit-feature'>
			<WorkspacePremiumOutlinedIcon size={18} />
			<Typography className={styles.featureText} variant={isMobile ? 'label2' : 'body1'}>
				Non-profit school
			</Typography>
		</span>
	);
};
